(function () {
  const roots = document.querySelectorAll('[data-bep-home-quiz]');
  if (!roots.length) return;

  const questions = [
    {
      text: "Quelle intention vous parle le plus aujourd’hui ?",
      options: [
        ["Retrouver davantage de calme", "calme"],
        ["Me sentir plus ancré(e)", "protection"],
        ["Prendre confiance dans mes choix", "confiance"],
        ["Retrouver de l’élan", "energie"],
        ["Choisir une symbolique douce", "coeur"]
      ]
    },
    {
      text: "Quel univers de couleurs préférez-vous ?",
      options: [
        ["Violet, blanc ou bleu doux", "calme"],
        ["Noir, brun ou gris", "protection"],
        ["Doré, brun chaud ou bleu profond", "confiance"],
        ["Rouge, orange ou tons volcaniques", "energie"],
        ["Rose, blanc ou vert tendre", "coeur"]
      ]
    },
    {
      text: "Votre bracelet sera surtout…",
      options: [
        ["Un rappel de ralentir", "calme"],
        ["Un symbole de stabilité", "protection"],
        ["Un repère pour oser", "confiance"],
        ["Un symbole de persévérance", "energie"],
        ["Un cadeau porteur d’attention", "coeur"]
      ]
    }
  ];

  const results = {
    calme: {
      title: "Améthyste, Howlite ou Sodalite",
      text: "Dans les traditions de lithothérapie, ces pierres sont associées au calme, à l’introspection et à la tempérance. Choisissez surtout selon la couleur, le diamètre des perles et le style qui vous attire.",
      url: "/collections/bracelet-serenite-pierres-naturelles",
      label: "Voir les bracelets Sérénité"
    },
    protection: {
      title: "Œil de Tigre, Onyx ou Pierre de Lave",
      text: "Ces pierres sont traditionnellement reliées à l’ancrage, au discernement et à la protection symbolique. Leur aspect sombre ou contrasté convient particulièrement aux styles sobres.",
      url: "/collections/bracelet-protection-pierre-naturelle",
      label: "Voir les bracelets Protection"
    },
    confiance: {
      title: "Œil de Tigre, Œil de Faucon ou Sodalite",
      text: "Dans les usages symboliques, ces pierres évoquent l’assurance, la clarté et l’affirmation de soi. Comparez les nuances et la présence visuelle avant de choisir.",
      url: "/collections/bracelets-confiance-en-soi-charisme",
      label: "Voir les bracelets Confiance"
    },
    energie: {
      title: "Œil de Taureau, Agate Rouge ou Pierre de Lave",
      text: "Ces pierres sont traditionnellement associées à la vitalité, à la persévérance et à l’élan. Elles se distinguent par leurs teintes chaudes et leur caractère marqué.",
      url: "/collections/bracelet-energie-vitalite",
      label: "Voir les bracelets Énergie"
    },
    coeur: {
      title: "Quartz Rose, Rhodonite ou Jade",
      text: "Leur symbolique traditionnelle est liée à la douceur, à l’affection et à la bienveillance. Elles constituent aussi des choix appréciés pour un cadeau délicat.",
      url: "/collections/bracelets-quartz-rose-naturel",
      label: "Voir les bracelets Quartz Rose"
    }
  };

  roots.forEach(function (root) {
    if (root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    let index = 0;
    const answers = [];
    const question = root.querySelector('[data-quiz-question]');
    const options = root.querySelector('[data-quiz-options]');
    const step = root.querySelector('[data-quiz-step]');
    const progress = root.querySelector('[data-quiz-progress]');
    const resultTitle = root.querySelector('[data-result-title]');
    const resultText = root.querySelector('[data-result-text]');
    const resultLink = root.querySelector('[data-result-link]');

    function render() {
      const current = questions[index];
      step.textContent = "Question " + (index + 1) + " sur " + questions.length;
      question.textContent = current.text;
      progress.style.width = (((index + 1) / questions.length) * 100) + "%";
      options.innerHTML = "";

      current.options.forEach(function (option) {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "bep-home-quiz__option";
        button.textContent = option[0];
        button.addEventListener("click", function () {
          answers.push(option[1]);
          index += 1;
          if (index < questions.length) render();
          else finish();
        });
        options.appendChild(button);
      });
    }

    function finish() {
      const scores = answers.reduce(function (acc, key) {
        acc[key] = (acc[key] || 0) + 1;
        return acc;
      }, {});
      const winner = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; })[0] || "calme";
      const result = results[winner];

      resultTitle.textContent = result.title;
      resultText.textContent = result.text;
      resultLink.href = result.url;
      resultLink.textContent = result.label;
      root.classList.remove("is-playing");
      root.classList.add("is-result");
    }

    root.querySelector('[data-quiz-start]').addEventListener("click", function () {
      index = 0;
      answers.length = 0;
      root.classList.remove("is-result");
      root.classList.add("is-playing");
      render();
    });

    root.querySelector('[data-quiz-restart]').addEventListener("click", function () {
      index = 0;
      answers.length = 0;
      root.classList.remove("is-result", "is-playing");
    });
  });
})();

(function () {
  function replaceExactText(root, from, to) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      const current = node.nodeValue.trim();
      if (current === from) {
        node.nodeValue = node.nodeValue.replace(from, to);
      }
    });
  }

  function patchHomepageChrome() {
    const header = document.querySelector('.bep-header-final');
    const footer = document.querySelector('.bep-footer-premium');

    if (header) {
      replaceExactText(header, 'Satisfait ou remboursé 14 jours', 'Rétractation sous 14 jours selon conditions');
      replaceExactText(header, 'Livraison offerte pour embellir vos poignets', 'Livraison gratuite en France');
      replaceExactText(header, 'Paiement 100% sécurisé', 'Paiement sécurisé');

      header.querySelectorAll('a[href="/collections/all"]').forEach(function (link) {
        if (link.classList.contains('bep-header-final__drawer-cta')) {
          link.setAttribute('href', '/collections/bracelets-pierres-naturelles');
        }
      });

      header.querySelectorAll('a[href="/pages/contact"]').forEach(function (link) {
        link.setAttribute('href', '/pages/contact-service-client');
      });
    }

    if (footer) {
      replaceExactText(footer, 'Paiement 100% sécurisé', 'Paiement sécurisé');
      replaceExactText(footer, 'Retours 14 jours', 'Rétractation sous 14 jours');
      replaceExactText(footer, 'Un achat simple, clair et rassurant.', 'Pour les produits non personnalisés, selon les conditions applicables.');
      replaceExactText(footer, 'Réponse sous 24 à 48h via notre', 'Une question avant ou après votre commande ? Utilisez notre');

      footer.querySelectorAll('a[href="/pages/contact"]').forEach(function (link) {
        link.setAttribute('href', '/pages/contact-service-client');
      });
      footer.querySelectorAll('a[href="/pages/faq"]').forEach(function (link) {
        link.setAttribute('href', '/pages/faq-foire-aux-questions');
      });
      footer.querySelectorAll('a[href="/pages/politique-de-retours-remboursements"]').forEach(function (link) {
        link.setAttribute('href', '/pages/livraison-et-retours');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchHomepageChrome, { once: true });
  } else {
    patchHomepageChrome();
  }
})();
